<template>
      <div
        class="col-12 col-sm-4 col-md-3 col-lg-2 column"
        style="cursor:pointer"
        @click="didClick"
      >
        <div class="pane">
          <h4 :class="{
            'small':true,
            'pane':true
            }">{{ listing.city }}, {{ listing.state }}</h4>
            <p v-for="field in tableFields" :key="field.id">
            <small style="color: gray">{{ field.name }}</small
            ><br />
            <a
            :href="'mailto:' + utils.findFieldValue(listing,field.name)"
            v-if="field.type == 'Email'"
            >{{utils.findFieldValue(listing,field.name)}}</a>
            <a
            target="_blank"
            :href="utils.findFieldValue(listing,field.name)"
            v-else-if="field.type == 'Website'"
            >{{utils.findFieldValue(listing,field.name)}}</a>
            <a v-else>{{utils.findFieldValue(listing,field.name)}}</a>
          </p>
          <small>Category</small>
          <p class="orange">{{listing.service.name}}</p>
          <small>Listed: {{timeAgo(listing)}}</small>
        </div>
      </div>
</template>

<script>
import Utils from "@/Utils/Utils";
import moment from 'moment';
export default {
  name: "MiniListingCard",
  components: {},
  data() {
    return {
      utils: Utils,
      showSort: false,
      selectedListing: null,
    };
  },
  props: {
    listing: {
      default: {},
    }
  },
  computed: {
    tableFields() {
      let fields = this.listing.fields.filter((it) => {
        return it.showInPreview == 1;
      });
      if (!fields) {
        return [];
      }

      return fields;
    }
  },
  methods: {
    timeAgo(listing) {
      return moment.utc(listing.dateListed).local().fromNow()
    },
    getImgUrl(pic) {
      return require("@/assets/" + pic);
    },
    toggleShowSearch() {
      console.log("show search");
      this.$emit("showSearch");
    },
    didClick() {
      let slug = this.listing.service.slug
      this.$router.push(`/feed/${slug}`)
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 768px) {
  .hidden-sm {
    display: none;
  }
}

.white {
  color: white;
}

.search {
  background: #f2f2f2;
  border-radius: 10px;
  margin: 0px;
  padding: 20px;
  margin-bottom: 20px;
}

.small {
  font-size: 90%;
}

.medium {
  font-size: 130%;
}

.large {
  font-size: 170%;
}

.pane {
  width: 100%;
  min-height: 50px;
  background: white;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
}

.row {
  margin-top: 20px;
}

.btn-blue {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/MiniListingCard.vue